import React from 'react'
import { NavLink } from 'react-router-dom'
import ScroolTop from '../tools/ScroolTop'
import Footer from '../tools/Footer'
import BarHorizontale from '../tools/BarHorizontale'

function NotFound() {
  return (
    <>
      <div className="d-flex flex-column" id="content-wrapper">
        <div id="content">
          <BarHorizontale />
          <div className="container-fluid">
            <div className="text-center mt-5">
              <div className="error mx-auto" data-text="404">
                <p className="m-0">404</p>
              </div>
              <p className="text-dark mb-5 lead">Page non trouvée</p>
              <p className="text-black-50 mb-0">Veuillez relancer la recherche avec une URL valide.</p>
              <NavLink to="/">← Retourner vers le Dashboard</NavLink>
            </div>
          </div>
        </div>
        <Footer />
      </div>
      <ScroolTop />
    </>
  )
}

export default NotFound